<div class="hide-left-small mb-2 opacity-50 font text-xs">
  {{ 'Employee Passport' | translate }}
</div>
@if (loading) {
  <offconon-mr-ai-working />
} @else {
  @if (selectedBusiness && !loading) {
    <div>
      <div class="flex items-center justify-between cursor-pointer">
        <div class="flex items-center left-menu-profile-holder">
          @if (profile_mini_parameters) {
            <offconon-profile-mini
              [parameters]="profile_mini_parameters"
              (clickEvent)="openSubPage(profile_link)" />
          }
        </div>

        <div>
          <button
            pButton
            icon="pi pi-ellipsis-v"
            class="p-button-text p-button-plain p-button-rounded hide-left-small"
            (click)="menu.toggle($event)"></button>
          <p-menu #menu [appendTo]="'body'" [popup]="true" [model]="items">
            <ng-template #item let-item>
              @if (item?.visible !== false) {
                <a class="flex items-center py-2 cursor-pointer gap-2">
                  <span
                    class="inline-flex items-center justify-center {{
                      item?.icon_color ? item?.icon_color : 'text-blue-500'
                    }}">
                    <mat-icon fontIcon="{{ item.icon ? item.icon : 'add_circle' }}" />
                  </span>
                  <span class="inline-flex flex-col gap-2 opacity-60">
                    <span class="font-light text-sm">{{ item.label }}</span>
                  </span>
                </a>
              }
            </ng-template>
          </p-menu>
        </div>
      </div>
    </div>
  }
}
